import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { ScanQROrderRequest } from '../models';
import { tap } from 'rxjs/operators';

@Injectable()
export class ScanQROrderService {
  private static config: any;

  constructor(private httpService: HttpService) {}

  public static getConfig() {
    return this.config;
  }

  public getScanQROrder(payload: ScanQROrderRequest): Observable<void> {
    return this.httpService.makePost<any, any>('getsolocompany', payload).pipe(tap((config) => (ScanQROrderService.config = config)));
  }
  public getScanQROrderDomain(payload: string): Observable<void> {
    return this.httpService.makePost<any, any>('getsolocompanydomain', payload).pipe(tap((config) => (ScanQROrderService.config = config)));
  }
  public setConfig(_config: any) {
    ScanQROrderService.config = _config;
  }
}
